var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.38 122.88",
    style: {
      enableBackground: "new 0 0 86.38 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.38,33.92L57.4,38.02c-1.31-3.28-2.47-5.54-3.52-6.81c-1.05-1.26-2.76-2.55-5.19-3.83v20.16 c14.11,3.78,23.54,7.76,28.29,11.92c6.26,5.64,9.4,12.76,9.4,21.42c0,5.05-1.12,9.71-3.38,13.92c-2.26,4.24-5.14,7.76-8.64,10.61 c-3.5,2.83-7.23,4.88-11.18,6.16c-3.95,1.29-8.78,2.02-14.49,2.26v9.05H38.55v-9.05c-6.83-0.59-12.37-1.69-16.63-3.28 c-4.24-1.59-7.92-3.81-11.02-6.64c-3.07-2.81-5.47-5.85-7.14-9.11C2.09,91.54,0.83,87.58,0,82.97l28.13-3.26 c0.83,4.57,1.98,7.88,3.4,9.9c1.4,2.02,3.76,3.83,7.02,5.4V70.36c-9.42-2.59-16.09-4.85-20.01-6.76c-3.93-1.9-7.33-4.97-10.21-9.19 C5.45,50.2,4,45.08,4,39.04c0-8.28,2.9-15.21,8.69-20.75c5.81-5.57,14.42-8.66,25.87-9.26V0h10.14v9.03 c10.42,0.64,18.39,3.09,23.92,7.38C78.1,20.67,81.72,26.5,83.38,33.92L83.38,33.92z M38.55,27.02c-3,0.98-5.07,2.19-6.23,3.62 s-1.76,3.14-1.76,5.09c0,2.02,0.6,3.81,1.78,5.31c1.19,1.52,3.26,2.78,6.21,3.81V27.02L38.55,27.02z M48.69,95.7 c3.95-0.88,6.83-2.36,8.66-4.38c1.83-2.02,2.76-4.31,2.76-6.81c0-2.19-0.79-4.21-2.33-6.07c-1.55-1.83-4.59-3.55-9.09-5.12V95.7 L48.69,95.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.9a564fc9.svg";
export { ForwardRef as ReactComponent };